import React from 'react';

import CircularIcon from '../../../design-system/CircularIcon/CircularIcon';
import CheckDoubleLineIcon from '../../../design-system/Icons/CheckDoubleLineIcon';

const EmptyView = ({ type }) => {
    return (
        <div className="py-[80px]">
            <CircularIcon icon={CheckDoubleLineIcon} centered marginBottom={16} />
            <div className="flex flex-col items-center gap-1">
                <p className="font-heading-bold text-heading-bold-m text-center">
                    {type === 'todo' && 'Hooooray!'}
                </p>
                <p className="font-body text-body-regular-m max-w-[440px] text-center">
                    {type === 'todo' && 'Great job keeping your inbox empty.'}
                </p>
            </div>
        </div>
    );
};

export default EmptyView;
